module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "No label"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Rounded"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "No label",
      "rounded": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Success",
      "type": "is-success"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Success"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Error",
      "type": "is-danger",
      "message": "You can have a message too"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Error"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Info",
      "type": "is-info"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Info"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Warning",
      "type": "is-warning"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Warning"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Disabled"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Disabled",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Loading"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Loading",
      "loading": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e2750e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/input/examples/ExTypesStates.vue
// module id = 1098
// module chunks = 13 215